import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';

const DefaultLayoutOverride = fr.metaOverride({ base: BaseOverride })
  .nameOverride('title', { hidden: true })
  .nameOverride('subtitle', { hidden: true });

export default DefaultLayoutOverride;
